import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-agenda-event-card',
  templateUrl: './agenda-event-card.component.html',
  styleUrls: ['./agenda-event-card.component.scss']
})
export class AgendaEventCardComponent {
  @Input() event;

  @Input() link;

  constructor() {}

}
